import { Button, Icon } from '@fashionnovateam/nova-ui-toolkit';

export function HeaderFilters() {
  return (
    <>
      <Button size="sm" color="secondary">
        <Icon.FilterHorizontal />
        <span>All Contacts</span>
      </Button>
      <Button size="sm" color="secondary">
        <Icon.FilterHorizontal />
        <span>All Priorities</span>
      </Button>
      <Button size="sm" color="secondary">
        <Icon.FilterHorizontal />
        <span>All Quote Statuses</span>
      </Button>
      <Button size="sm" color="secondary">
        <Icon.FilterHorizontal />
        <span>All Vendor Sample Statuses</span>
      </Button>
    </>
  );
}
